import ModuleCustomer from 'mfCustomer/Customer';

/**
 * simple re-export of the customer module, allowing for mocks
 * (the promise based alias 'mfCustomer/*' cant be mocked directly) to be used in tests
 */
export { ModuleCustomer };
